export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-smartphone-line mr-1"></i>随时随地
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">移动观影</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              陌陌影视移动端适配完美，无需下载任何App，手机浏览器打开即可畅享高清观影体验。
              支持iOS和Android全平台，通勤路上、午休间隙，随时随地发现好电影。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-8 mb-6">
              <div className="text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-2">
                  <i className="ri-smartphone-line text-2xl"></i>
                </div>
                <p className="text-xs text-foreground-500">手机浏览器直达</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-2">
                  <i className="ri-computer-line text-2xl"></i>
                </div>
                <p className="text-xs text-foreground-500">电脑大屏观影</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-secondary-200 text-secondary-600 mx-auto mb-2">
                  <i className="ri-tablet-line text-2xl"></i>
                </div>
                <p className="text-xs text-foreground-500">平板沉浸体验</p>
              </div>
            </div>
            <div className="flex items-center justify-center lg:justify-start gap-3">
              <button className="px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-lg whitespace-nowrap cursor-pointer transition-colors">
                <i className="ri-safari-line mr-2"></i>浏览器打开
              </button>
              <button className="px-7 py-3 bg-background-50 hover:bg-background-200 text-foreground-700 border border-secondary-200 text-sm font-medium rounded-lg whitespace-nowrap cursor-pointer transition-colors">
                <i className="ri-bookmark-line mr-2"></i>加入收藏
              </button>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-[240px] h-[480px] md:w-[280px] md:h-[540px] rounded-3xl overflow-hidden border-4 border-secondary-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20dark%20cinematic%20theme%2C%20film%20poster%20thumbnails%20grid%20layout%2C%20warm%20accent%20colors%20on%20dark%20background%2C%20modern%20mobile%20UI%20design%2C%20movie%20category%20tabs%20at%20top%2C%20rich%20dark%20interface%20with%20gold%20and%20red%20highlights%2C%20no%20visible%20text%20or%20logos&width=560&height=1080&seq=app-mockup-momo&orientation=portrait"
                alt="陌陌影视移动端界面预览"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}